<template>
    <div class="sku-list">
        <div class="line">
            <div class="lf">
                <vs-input class="input-item" placeholder="请输入商品69码、名称" v-model="goodsName" />
                <vs-button type="border" color="primary" icon-pack="feather" class="search" @click='searchGoods'>查询</vs-button>
                <template v-if="newOrder">
                    <div class="marLeft-10">订单币种：</div>
                    <v-select id='currencySelect'
                              :options="currencyTypeList" v-model="currencyType"
                              :reduce="opt => opt.id"  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              placeholder="请选择订单币种"/>
                </template>
            </div>
            <div v-if="editFlag == 'true' || newOrder">
                <vs-button color="primary" @click="showPayType" icon-pack="feather" class="btn">添加支付</vs-button>
                <vs-button color="primary" @click="addGoods" icon-pack="feather" class="btn">添加商品</vs-button>
            </div>
        </div>
        <div v-for="(item, index) in splitGoodsList" :key="index">
            <div class="order-title">订单{{index+1}}</div>
            <vs-table :data="item.List" noDataText="暂无数据">
                <template slot="thead">
                    <vs-th :class="headData.thClass?headData.thClass:''" v-for="(headData, index) in headData" :key="index">{{ headData.name }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :class="tr.availableAmount ? '' : 'amount-red'">
                        <vs-td :data="tr.goodsCategoryName" style="width:120px"><span v-show="tr.hunitPrice == 0" style="color:red;">(赠)</span> {{ tr.goodsCategoryName }}</vs-td>
                        <vs-td :data="tr.skuName" style="width:260px">{{ tr.skuName }}</vs-td>
                        <vs-td :data="tr.skuCode" style="width:160px">{{ tr.skuCode }}</vs-td>
                        <vs-td :data="tr.barCode" style="width:180px">{{ tr.barCode }}</vs-td>
                        <vs-td :data="tr.num" class='modify' style="width:120px">
                            <template v-if="tr.editFlag">
                                <gc-cmp-vs-input v-model="tr.num" class="table-edit-input" type="number" />
                            </template>
                            <template v-else>{{tr.num > 0 ? tr.num + tr.unit : 0 + tr.unit}}</template>
                        </vs-td>
                        <vs-td style="width:120px">{{tr.sendSpecNum}}</vs-td>
                        <vs-td :data="tr.untilPrice" class="text-right" style="width:80px">{{ tr.untilPrice | currencyFormat(2, true) }}</vs-td>
                        <vs-td :data="tr.hunitPrice" class='modify text-right' style="width:100px">
                            <template  v-if="tr.editFlag">
                                <gc-cmp-vs-input v-model="tr.hunitPrice" class="table-edit-input" type="number" />
                                <!-- @change="hunpriceChange(tr, indextr)" -->
                            </template>
                            <template v-else>{{(tr.hunitPrice > 0 ? tr.hunitPrice : 0) | currencyFormat(2, true)}}</template>
                        </vs-td>
                        <vs-td :data="tr.itemPrice" class="text-right" style="width:160px">{{ tr.itemPrice | currencyFormat(2, true) }}</vs-td>
                        <vs-td :data="tr.hitemPrice" class="text-right" style="width:160px">{{ tr.hitemPrice | currencyFormat(2, true)}}</vs-td>

                        <vs-td :data="tr.actualAmount" class="text-center" style="width:120px">{{ tr.availableAmount || 0 }}</vs-td>
                        <!-- 发货仓/快递单号 -->
                        <vs-td :data="tr.sendWs" style="width:120px">{{ sendWs }}</vs-td>
                        <vs-td style="width:120px">
                            <div v-if="billSendBo  && (billSendBo.expressProvider != '' || billSendBo.expressNo != '')">
                                <div>
                                    {{ billSendBo.expressProvider}}
                                </div>
                                <div>
                                    {{ billSendBo.expressNo}}
                                </div>
                            </div>
                        </vs-td>
                        <vs-td v-if="editFlag == 'true' || newOrder" style="width:120px">
                            <vs-button color="primary" class="a_btn" type="flat" @click.stop="addedit(tr,indextr)" v-if='!tr.editFlag'>编辑</vs-button>
                            <vs-button color="primary" class="a_btn" type="flat" @click.stop="editAndSave(tr, indextr)"  v-if='tr.editFlag'>保存</vs-button>
                            <vs-button color="primary" class="a_btn" type="flat" @click="deleteOrderGoods(tr, indextr)">删除</vs-button>
                        </vs-td>
                        <vs-td v-else>-</vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <div class="amount-wrap" v-if="orderGoodsList.length">
                <div class="alignCenter">
                    <span>币种</span>
                    <span class="amount-value">{{currencyShow}}</span>
                </div>
                <div class="alignCenter">
                    <span>成交总金额</span>
                    <span class="amount-value">{{item.hunitPricenum  | currencyFormat( 2, false, currencySymbol)}}</span>
                </div>

                <div class="alignCenter marTop5">
                    <span>原价总金额</span>
                    <span class="amount-value">{{item.itemPricenum | currencyFormat( 2, false, currencySymbol)}}</span>
                </div>

                <div class="alignCenter marTop5">
                    <span>实付总金额</span>
                    <span class="amount-value">{{item.Paidinamount | currencyFormat( 2, false, currencySymbol)}}</span>
                </div>

                <div class="alignCenter marTop5">
                    <span>折扣总金额</span>
                    <span class="amount-value">{{item.discount | currencyFormat( 2, false, currencySymbol)}}</span>
                </div>
            </div>
        </div>


        <!-- 新增商品的时候需要有支付信息 -->
        <div class="pay-wrap" v-if='newOrder && payTypeList && payTypeList.length'>
            <h1>支付信息</h1>
            <div class="alignCenter marTop5 pay-info" v-for="(item,index) in payTypeList" :key="index">
                <span>手工支付</span>
                <div>
                    <span>订单名称</span>
                    <span>{{item.title}}</span>
                </div>

                <div>
                    <span>支付金额</span>
                    <span>{{item.payPrice | currencyFormat( 2, false, currencySymbol)}}</span>
                </div>

                <div>
                    <span>支付方式</span>
                    <span>{{item.payTypeName}}</span>
                </div>

                <div style="width:160px">
                    <span>支付时间</span>
                    <span>{{item.payTime}}</span>
                </div>

                <div>
                    <span>支付单号</span>
                    <span>{{item.payNo}}</span>
                </div>

                <vs-button type="filled" size="small" class="marLeft16" @click='cancelPay(index)'>取消</vs-button>
            </div>
        </div>
        <!-- 新增商品 -->
        <vs-popup classContent="popup-example deliver-pop new-goods-pop" :title="newOrder ? '新增商品' : '更新商品'" :active.sync="isShowUpdateForm" class='goods-popup'>
            <div class="filterWrap marTop18">
                <div class="flex">
                    <v-select class="category-select" clearable multiple v-model="categoryIdList" :options="categoryList" :reduce="opt => opt.id" placeholder="请选择商品分类">
                        <div slot="no-options">暂无选项</div>
                    </v-select>
                    <gc-cmp-vs-input v-model="suggest" class="filterInput marLeft16" placeholder='商品名称/商品编码' />
                    <vs-button type="filled" size="small" @click.prevent="getTableData(1, true)" class="marLeft16">查询</vs-button>
                </div>
            </div>

            <vs-table :data="goodsList" noDataText="暂无数据">
                <template slot="thead">
                    <vs-th>商品分类</vs-th>
                    <vs-th>69码</vs-th>
                    <vs-th>商品名称</vs-th>
                    <vs-th>可用库存</vs-th>
                    <vs-th>原价</vs-th>
                    <vs-th>成交价</vs-th>
                    <vs-th>数量</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="tr.goodsCategoryName">{{ tr.goodsCategoryName }}</vs-td>
                        <vs-td :data="tr.barCode">{{ tr.barCode }}</vs-td>
                        <vs-td :data="tr.skuName">{{ tr.skuName }}</vs-td>
                        <vs-td :data="tr.availableAmount">{{ tr.availableAmount }}</vs-td>
                        <vs-td :data="tr.untilPrice">{{ (tr.untilPrice > 0 ? tr.untilPrice : 0)| currencyFormat(2, true) }}</vs-td>
                        <!-- <vs-td :data="tr.hunitPrice">{{ (tr.hunitPrice > 0 ? tr.hunitPrice : 0) | currencyFormat(2, true) }}</vs-td> -->
                        <vs-td><vs-input @mousewheel.prevent v-model="tr.hunitPrice" @change="priceChange(tr,indextr)"  class="w-full" type="number" placeholder="请输入成交价"/></vs-td>
                        <vs-td><vs-input
                                @mousewheel.prevent
                                v-model="tr.num"
                                @change="numberChange(tr,indextr)"
                                class="w-full"
                                type="number"
                                placeholder="请输入数量"/></vs-td>
                        <!-- <vs-td><vs-input @mousewheel.prevent v-model="goodsNum[indextr]" @change="numberChange(tr,indextr)" class="w-full" type="number" placeholder="请输入数量"/></vs-td> -->
                    </vs-tr>
                </template>
            </vs-table>
            <gc-vs-pagination-nosize :total="pager.total" v-model="pager.page" :max-items="pager.size" :goto="true" class="marTop16"></gc-vs-pagination-nosize>
            <div class="deliver-btn flex flexCenter">
                <vs-button color="primary" type="filled" @click="comfirmAddGoods">确认</vs-button>
            </div>
        </vs-popup>

        <!-- 添加支付-->
        <vs-popup classContent="popup-example deliver-pop" title="添加新的支付" :active.sync="isShowPayType">
            <form class="frombox" id="data-list-list-view">
                <vs-row class="alignCenter">
                    <vs-col  vs-w="3" class="colTitle">订单名称</vs-col>
                    <vs-col vs-w="5">
                        <v-select :options="payOrder" v-model="payData.payRecord.bodyId" :reduce="opt => opt.id" placeholder="请选择订单"/>
                    </vs-col>
                </vs-row>
                <vs-row class="alignCenter marTop20">
                    <vs-col  vs-w="3" class="colTitle">支付方式</vs-col>
                    <vs-col vs-w="5">
                        <v-select :options="payList" v-model="payData.payRecord.payType"  label="val"  :reduce="opt => opt.key"  :dir="$vs.rtl ? 'rtl' : 'ltr'" placeholder="请选择支付方式"/>
                    </vs-col>
                </vs-row>

                <vs-row class="alignCenter marTop20">
                    <vs-col  vs-w="3" class="colTitle">支付时间</vs-col>
                    <flat-pickr v-model="payData.payRecord.payTime" data-enable-time=true data-enable-seconds=true :config="flatPickerConfig" placeholder="请选择支付时间" class="time-item-lf" />
                </vs-row>

                <vs-row class="alignCenter marTop20">
                    <vs-col  vs-w="3" class="colTitle">支付单号</vs-col>
                    <vs-col vs-w="9"><vs-input v-model="payData.payRecord.payNo" class="w-full"  placeholder="请输入支付单号"/></vs-col>
                </vs-row>

                <vs-row class="alignCenter marTop20">
                    <vs-col  vs-w="3" class="colTitle">支付金额</vs-col>
                    <vs-col vs-w="9"><vs-input v-model="payData.payRecord.payPrice" type="number" class="w-full"  placeholder="请输入支付支付金额"/></vs-col>
                </vs-row>
            </form>
            <div class="deliver-btn flex flexCenter">
                <vs-button color="primary" type="filled" @click="comfirmAddPaySource">确认</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
    import vSelect from 'vue-select';
    import GcCmpVsInput from '@/group-cloud/components/vsInput';
    import { OrderGoodsApi } from '@/modules/server-api/commodity-sys/order-goods';
    import {OrderApi} from "@/modules/server-api/commodity-sys/order";
    import { CommodityCategoryApi } from '@/modules/server-api/commodity-sys/category-manage';
    import { getThreeCategory, $busErrorCode } from '@/modules/commodity-sys/common.js';
    export default {
        props: {
            skuData: {
                type: Array,
                default: null
            },
            orderGoodsList: {//订单关联的商品
                type: Array,
                default: () => { return [];}
            },
            orderNo: {
                type: String,
                default: ""
            },
            sourceChannel: {
                type: String,
                default: ""
            },
            editFlag:{
                type: Boolean,
                default: false
            },
            //是否是新增的订单
            newOrder:{
                type: Boolean,
                default: false
            },
            buyer: {
                type: [String, Number],
                default: null
            },
            addcustype: {
                type: [String],
                default: null
            },
            payTypeList:{
                type: Array,
                default: () => { return [];}
            },
            buyerTypeNum: {
                type: [String, Number],
                default: null
            },
        },

        data() {
            return {
                isShowPayType:false,         //添加新的支付弹框
                isShowUpdateForm: false,
                goodsData: [],
                goodsListSelect:[],
                goodsPriceSelect:[],
                goodsName:"",
                billSendBo:{},
                currencySymbol: '', //订单币种
                currencyType:'',
                currencyShow: 'RMB',
                currencyTypeList:[
                    {id: 'RMB', label: 'RMB', symbol:'￥'},
                    {id: 'USD', label: 'USD', symbol:'$'}
                ],
                // headData: ['SKU编码', '69码', '商品名称', '类别', '数量', '原价', '成交价', '原价金额', '成交金额', '可用库存','操作'],
                headData: [
                    {
                        name:'类别',
                    },
                    {
                        name:'商品名称',
                    },
                    {
                        name:'sku编码',
                    },
                    {
                        name:'69码',
                    },
                    {
                        name:'下单数量',
                    },
                    {
                        name:'发货数量',
                    },
                    {
                        name:'原价',
                        thClass:'text-right'
                    },
                    {
                        name:'成交价',
                        thClass:'text-right'
                    },
                    {
                        name:'原价金额',
                        thClass:'text-right'
                    },
                    {
                        name:'成交金额',
                        thClass:'text-right'
                    },
                    {
                        name:'可用库存',
                    },
                    {
                        name:'发货仓',
                    },
                    {
                        name:'快递/物流',
                    },
                    {
                        name:'操作',
                    },
                ],
                payData:{
                    orderNo:"",
                    payRecord:{
                        payType:"",
                        payTypeName: "",
                        payTime:"",
                        payNo:"",
                        payPrice:""
                    }
                },
                payList:[],     //支付方式列表
                flatPickerConfig: {
                    locale: Mandarin //日期控件中文
                },
                suggest: "",            //搜索框
                categoryIdList:"",          //商品分类
                categoryList:[],            //商品分类
                goodsList:[],                //商品列表
                goodsNum:[],              //商品数量
                searchGoodsList:[],         //筛选的商品
                pager: {
                    page: 1,
                    size: 20,
                    total: 0
                },
                amountInfo:{
                    actualTotalPrice: 0, //实付总金额
                    dealTotalPrice: 0, //成交总金额
                    originalTotalPrice: 0,//原价总金额
                    discountTotalPrice: 0 //折扣总金额
                },                  //价格信息
                addPayList:[],              //新增的支付信息,
                editGoodsInfo:{},			//当前修改商品信息
                modifyNum:[],
                modifyPrice:[],
                buttonText:"编辑",
                sendWs: '', //发货仓
                express: '',  //快递/物流单号
                selectOldList : [], //存储已经存在的问题
                uid: 0,  //配置当前订单商品id
                splitGoodsList: [], //拆单商品列表
                payOrder: [], //订单名称列表
            }
        },

        mounted() {
            this.getEvenyGoods(this.orderGoodsList)
        },

        filters: {
            formatPrice(value){
                // console.log('formatPrice',value)
                if(value){
                    return Number(Number(value).toFixed(2))
                }
                return '0.00'
            }
        },

        methods: {
            // 阻止滚动条滚动
            stopScroll() {
                document.body.style.top = '0'
                document.body.style.position = 'fixed'
                document.body.style.height = '100%'
                document.body.style.overflow = 'hidden'
            },
            // 恢复滚动条滚动
            autoScroll() {
                document.body.style.position = 'initial'
                document.body.style.overflowY = 'auto'
            },
            //新增支付方式
            async showPayType(){

                // 清空信息
                this.payData.payRecord = {
                    payType:"",
                    payTypeName: "",
                    payTime:"",
                    payNo:"",
                    payPrice:""
                }
                let res = await OrderGoodsApi.PaysList({})
                this.getEvenyOrder();
                this.payList = res.result;
                this.isShowPayType = true;
                // this.stopScroll()
            },


            //确认新增支付方式
            async comfirmAddPaySource(){
                // console.log("新增支付：",this.payData.payRecord)
                const {bodyId,payType,payTime,payNo,payPrice} = this.payData.payRecord;
                if(!bodyId){
                    return this.$notifyError('请先添加商品，再选择订单名称');
                }
                if(!payType){
                    return this.$notifyError('请选择支付方式');

                }else{
                    //获取支付方式名称
                    this.payList.map(item =>{
                        if(item.key == payType){
                            this.payData.payRecord.payTypeName = item.val;
                        }
                    })
                }

                if(!payTime){
                    return this.$notifyError('请选择支付时间');
                }
                if(!payNo){
                    return this.$notifyError('请选择支付单号');
                }
                if(!payPrice){
                    return this.$notifyError('请输入支付金额');
                }
                //新增订单
                if(this.newOrder){
                    this.payTypeList.push(this.payData.payRecord);
                    this.payTypeList.map(item => {
                        this.payOrder.map(ele => {
                            if(ele.id == item.bodyId){
                                item.title = ele.label;
                            }
                        })
                    })
                    console.log('payTypeList', this.payTypeList)
                    this.$notifySuccess('新增支付方式成功');
                    this.isShowPayType = false;

                    this.getEvenyOrder();
                    // this.amountInfo.actualTotalPrice = null
                    // this.payTypeList.forEach((item,index)=>{
                    //     this.amountInfo.actualTotalPrice += Number(item.payPrice)
                    // })
                    // this.amountInfo.actualTotalPrice = Number(this.amountInfo.actualTotalPrice.toFixed(2))
                    // // 折扣总金额
                    // this.amountInfo.discountTotalPrice = Number(Number(this.amountInfo.originalTotalPrice - this.amountInfo.dealTotalPrice).toFixed(2));



                    // this.autoScroll()
                    // console.log("支付方式", this.payTypeList);
                    this.$emit("getPayInfo",this.payTypeList);
                    // this.autoScroll()
                }else{//编辑订单
                    this.payData.orderNo = this.orderNo
                    let res = await OrderApi.AddPayType(this.payData);
                    if (res.succ == 1 && res.code != $busErrorCode) {
                        this.$notifySuccess('新增支付方式成功');
                        this.isShowPayType = false;
                        // this.autoScroll()
                        this.getOrderGoodsList()
                    } else {
                        return this.$notifyError(res.error);
                    }
                }
            },
            //取消支付
            cancelPay(index){
                // console.log("取消支付==", this.payTypeList);
                this.payTypeList.splice(index,1);
                // console.log("取消支付后==", this.payTypeList);

                this.amountInfo.actualTotalPrice = 0;
                this.payTypeList.forEach((item,index)=>{
                    this.amountInfo.actualTotalPrice += Number(item.payPrice)
                })
                // 折扣总金额
                this.amountInfo.discountTotalPrice = Number(Number(this.amountInfo.originalTotalPrice - this.amountInfo.dealTotalPrice).toFixed(2));

                this.$emit("getPayInfo",this.payTypeList)
            },
            //获取该订单关联的商品
            async getOrderGoodsList(){
                let orderGoodsList = await OrderApi.getOrderGoods({orderNo: this.orderNo, goodLoc: 1});
                this.orderGoodsList = orderGoodsList.result.skuItems;
                if(this.orderGoodsList.length){
                    //获取币种
                    let currency = this.orderGoodsList[0].currency || this.currencyTypeList[0].id;
                    this.currencyType = currency;
                    const cIndex = this.currencyTypeList.findIndex(item => item.id == currency);
                    this.currencySymbol = this.currencyTypeList[cIndex].symbol;
                    this.currencyShow = this.currencyTypeList[cIndex].id;

                    this.orderGoodsList = this.orderGoodsList.map((item,index)=>{
                        this.$set(item,"editFlag",false)
                        //格式化金额
                        item.hunitPrice = this.formatPrice(item.hunitPrice);
                        item.untilPrice = this.formatPrice(item.untilPrice);
                        item.itemPrice = this.formatPrice(item.itemPrice);
                        item.hitemPrice = this.formatPrice(item.hitemPrice);
                        item.offerFlag = item.orderType == '1' ? true : false;
                        return item;
                    })
                }
                //获取物流单号及发货仓
                this.sendWs = orderGoodsList.result.sendWs;
                this.express = orderGoodsList.result.express;
                this.billSendBo = orderGoodsList.result.billSendBo;
                //sessionStorage.setItem("searchGoodsList",this.orderGoodsList)
                this.searchGoodsList = this.orderGoodsList;
                this.amountInfo = orderGoodsList.result;
                let addPayList = orderGoodsList.result.payRecords;
                let sellerRemark = orderGoodsList.result.sellerRemark;
                let receiveInfo = {receiveName:orderGoodsList.result.receiveName,receivePhone:orderGoodsList.result.receivePhone,address:orderGoodsList.result.address};
                this.$emit("getAddPayList",addPayList);
                this.$emit("getSellerRemark",sellerRemark);
                this.$emit("getReceiveInfo",receiveInfo);
                this.$emit("getAmountInfo",this.amountInfo);
            },

            //新增商品
            async addGoods(){
                if(!this.currencyType || this.currencyType == ''){
                    this.$notifyError('请您先选择订单币种');
                }else if(!this.newOrder || this.buyer){
                    this.suggest = "";           //搜索框
                    this.categoryIdList = [];
                    this.goodsList = [];
                    this.getCategoryOptions()
                    this.isShowUpdateForm = true
                } else{
                    return this.$notifyError('请先选择买家类型');
                }
                console.log(this.sourceChannel);
            },

            //获取分类数据
            async getCategoryOptions() {
                this.categoryList = [];
                let resCategoryList = await CommodityCategoryApi.getCategoryList({});
                let resList = resCategoryList.result;
                if (resList) {
                    //获取三级分类
                    let finalList = [];
                    resList.map(item => {
                        let child = getThreeCategory(item);
                        if (child && child.length > 0) {
                            child.map(item => finalList.push(item));
                        }
                    });
                    finalList &&
                    finalList.map(item => {
                        let obj = {};
                        obj.id = item.id;
                        obj.label = item.categoryName;
                        this.categoryList.push(obj);
                    });
                }
            },

            //获取新增商品列表
            async getTableData(page, searchFlag) {
                // console.log('this.goodsListSelect===999',this.goodsListSelect)
                this.pager.page = page || this.pager.page;
                console.log(this.addcustype);
                let pageSize = this.pager.size;
                if(searchFlag){
                    //清空
                    this.goodsNum = [];
                }
                let param = {
                    pageNo: this.pager.page,
                    pageSize: pageSize,
                    data: {
                        buyerType: this.buyerTypeNum,
                        suggest: this.suggest,
                        categoryIdList: this.categoryIdList,
                        goodsType: "NORMAL",
                        returnMoneyFlag:true,
                        sourceChannel:this.sourceChannel
                    }
                };
                if(this.newOrder){//新增
                    if(this.addcustype==2){
                        param.data.buyer = 'store' + this.buyer;
                    }else{
                        param.data.buyer = this.buyer;
                    }

                }else{//编辑
                    param.data.orderNo = this.orderNo;
                }
                let  resp = await OrderGoodsApi.getAllGoodsList(param);
                this.goodsList = resp.result.list.map((item,index) =>{
                    //格式化金额
                    item.hunitPrice = this.formatPrice(item.hunitPrice);
                    item.untilPrice = this.formatPrice(item.untilPrice);
                    item.num = '';

                    //判断是否已添加，如需保存现有的数量需放开
                    // let existsIndex = this.goodsListSelect.findIndex(good => good.barCode == item.barCode);
                    // if(existsIndex != -1){
                    //   this.goodsNum[index] = this.goodsListSelect[existsIndex].num;
                    // }
                    return item;
                });

                // 过滤已经添加的商品
                // if (this.orderGoodsList) {
                //   this.orderGoodsList.map(good =>{
                //     this.goodsList = this.goodsList.filter(item => item.barCode != good.barCode)
                //   })
                // }
                // todo
                if (this.goodsListSelect.length > 0) {
                    this.goodsList.map(item => {
                        this.goodsListSelect.map(ele => {
                            if (item.barCode == ele.barCode) {
                                item.num = ele.num
                                item.hunitPrice = ele.hunitPrice
                            }
                        })
                    })
                }
                // 成交价回显  todo
                if (this.orderGoodsList.length > 0) {
                    this.goodsList.map(item => {
                        this.orderGoodsList.map((ele,idx) => {
                            if (item.barCode == ele.barCode && ele.hunitPrice != 0) {
                                item.hunitPrice = '0.00'
                                item.num = ''
                            }
                        })
                    })
                }
                this.pager.total = Math.ceil(resp.result.totalCount / pageSize);
                this.$forceUpdate();
            },
            //格式化金额
            formatPrice(price, fixedNum){
                price = Number(price);
                fixedNum = fixedNum || 2;
                if(price > 0){
                    return parseFloat(price).toFixed(fixedNum);
                }else{
                    return '';
                }
            },

            //确认新增商品
            async comfirmAddGoods(){
                let addSkuItemList = []
                //获取输入数量的商品
                this.goodsList.forEach(good => {
                    if (good.num) {
                        if (!this.goodsListSelect.length) {
                            this.goodsListSelect.push(good)
                        }
                    }
                })

                let skuItemList = sessionStorage.getItem("addSkuItemList");
                //this.goodsListSelect = []
                // 判断当前列表是否存在新增商品   todo
                if(!skuItemList) {
                    skuItemList = []
                } else {
                    skuItemList = JSON.parse(skuItemList)
                }
                let passFlag = true;
                if(!this.goodsListSelect.length){
                    passFlag = false;
                    return this.$notifyError('请输入需要增加商品的数量');
                }else{
                    this.goodsListSelect.forEach((item,index)=>{
                        //添加币种
                        item.currency = this.currencyType;
                        //新增单据
                        if(this.newOrder){
                            //原价金额
                            item.itemPrice = isNaN(item.untilPrice) ? 0 : Number(item.num) * Number(item.untilPrice);
                            //成交金额
                            item.hitemPrice = isNaN(item.hunitPrice) ? 0 : Number(item.num) * Number(item.hunitPrice);
                            //TODO:添加本地缓存的时候会需要缓存商品，addSkuItemList会有重的
                            addSkuItemList.push(item);
                        }else{
                            const exIndex = addSkuItemList.length == 0 ? -1 : addSkuItemList.findIndex(good => good.barCode == item.barCode);
                            if(exIndex == -1){
                                addSkuItemList.push({skuCode:item.skuCode, num:item.num, hunitPrice: item.hunitPrice, currency: this.currencyType, offerFlag: item.offerFlag, skuName:item.skuName});
                            }
                        }
                    })
                    this.$notifySuccess('新增商品成功');
                }

                if(!addSkuItemList.length){
                    passFlag = false;
                    return this.$notifyError('请输入需要增加商品的数量');
                }
                if(passFlag){
                    let param = {};
                    if(this.newOrder){
                        this.isShowUpdateForm = false;
                        // this.computeTotalPrice(addSkuItemList);
                        addSkuItemList.map(item =>{
                            // console.log("this.amountInfo", this.amountInfo);
                            //是否存在已添加的商品
                            let existsGood = this.orderGoodsList.filter(good => good.uid == item.uid && good.num == item.num);
                            if(existsGood.length == 0){
                                skuItemList.push(item);
                                this.orderGoodsList.push(item);
                            }else{
                                passFlag = false;
                                // return this.$notifyError("商品"+item.skuName + '已存在,请删除后再次添加1');
                            }
                        })

                        // this.amountInfo.dealTotalPrice = Number(this.amountInfo.dealTotalPrice.toFixed(2))
                        // this.amountInfo.originalTotalPrice = Number(this.amountInfo.originalTotalPrice.toFixed(2))

                        // // 折扣总金额
                        // this.amountInfo.discountTotalPrice = Number(Number(this.amountInfo.originalTotalPrice - this.amountInfo.dealTotalPrice).toFixed(2));
                        this.goodsNum = [];
                        this.searchGoodsList = JSON.parse(JSON.stringify(this.orderGoodsList));
                        this.selectOldList = [];
                        // console.log('===skuItemList===currency===', skuItemList);
                        sessionStorage.setItem("addSkuItemList",JSON.stringify(skuItemList));
                    }else{
                        let isAdd;
                        addSkuItemList.map(item => {
                            let existsGood = this.orderGoodsList.filter(good => good.offerFlag == item.offerFlag && good.skuCode == item.skuCode);
                            if(existsGood.length != 0){
                                isAdd = false;
                                return this.$notifyError("商品"+item.skuName + '已存在,请删除后再次添加');
                            }else{
                                isAdd = true;
                            }
                        })
                        if(isAdd){
                            let res = await OrderGoodsApi.addGoods({ orderNo: this.orderNo,updateSkuItemList:addSkuItemList});
                            if (res.succ == 1) {
                                if(res.code == 0){
                                    this.getOrderGoodsList();
                                    this.isShowUpdateForm = false;
                                    this.$notifySuccess('新增商品成功');
                                }
                                else{
                                    this.$notifyError(res.error);
                                }
                                sessionStorage.setItem("addSkuItemList",JSON.stringify(skuItemList));
                            } else {
                                this.$notifyError(res.error);
                            }
                        }
                    }
                    //清空
                    this.goodsNum = []; //todo
                    setTimeout(()=>{
                        this.getpicenum();
                    })

                }
            },
            //计算每个商品的和
            getpicenum(){
                console.log(this.splitGoodsList)
                this.splitGoodsList.map(item=>{
                    item.hunitPricenum=0
                    item.itemPricenum=0
                    item.List.map(inasd=>{
                        console.log(inasd.hunitPrice,inasd.itemPrice)
                        //成交金额总价
                        item.hunitPricenum += Number(inasd.hunitPrice)
                        //原价总价
                        item.itemPricenum += Number(inasd.itemPrice)
                    })
                    console.log(item)
                })
            },
            async deleteOrderGoods(row) {
                this.$vs.dialog({
                    type: 'confirm',
                    title: `操作提示`,
                    text: `您确认删除该商品吗？`,
                    acceptText: '确认',
                    cancelText: '取消',
                    accept: () => {
                        this.doDeleteOrderGoods(row);
                    }
                });
            },
            async doDeleteOrderGoods(row) {
                if(this.newOrder){
                    console.log(this.splitGoodsList)
                    console.log(this.payTypeList,this.goodsListSelect)
                    this.orderGoodsList=JSON.parse(sessionStorage.getItem("addSkuItemList"))
                    console.log(this.orderGoodsList)
                    let uid = row.uid;
                    let leftList = this.orderGoodsList.filter((item,index)=>{
                        return item.uid != uid
                    })

                    sessionStorage.setItem("addSkuItemList",JSON.stringify(leftList));
                    this.orderGoodsList = JSON.parse(sessionStorage.getItem("addSkuItemList"));
                    this.searchGoodsList = JSON.parse(JSON.stringify(this.orderGoodsList))
                    this.goodsListSelect = this.goodsListSelect.filter(item => item.uid != uid)
                    console.log(this.payTypeList,this.goodsListSelect)
                    let objlist = []
                    this.goodsListSelect.map(item=>{
                        this.payTypeList.map((indes,index)=>{
                            if(indes.bodyId==item.bodyId){
                                //
                                console.log(indes,index)
                                objlist.push(indes)
                            }else{
                                console.log(indes,index)
                                // this.payTypeList.splice(index,1)
                            }
                        })
                    })
                    this.payTypeList=objlist
                    this.amountInfo.actualTotalPrice = 0;
                    this.payTypeList.forEach((item,index)=>{
                        this.amountInfo.actualTotalPrice += Number(item.payPrice)

                    })
                    this.amountInfo.actualTotalPrice = Number(this.amountInfo.actualTotalPrice.toFixed(2))
                    // 折扣总金额
                    this.amountInfo.discountTotalPrice = Number(Number(this.amountInfo.originalTotalPrice - this.amountInfo.dealTotalPrice).toFixed(2));
                    // this.autoScroll()
                    console.log(this.payTypeList)
                    //修改金额
                    this.computeTotalPrice(this.orderGoodsList);
                    this.splitGoodsList = this.orderGoodsList
                    this.$notifySuccess('删除成功');
                    //  let addsb=[]
                    //  this.splitGoodsList.map(iten=>{
                    //    iten.List.map(inds=>{
                    //      inds.editFlag = false
                    //      addsb.push(inds)
                    //    })
                    //  })
                    //  sessionStorage.setItem("addSkuItemList",JSON.stringify(addsb));
                    console.log(this.splitGoodsList)
                    this.getEvenyGoods(JSON.parse(sessionStorage.getItem("addSkuItemList")));
                    this.getEvenyOrder();
                }else{
                    let res = await OrderGoodsApi.deleteGoods({ orderNo: this.orderNo,id: row.id, skuCodeList:[row.skuCode]});
                    if (res.succ == 1) {
                        if(res.code == 0){
                            this.$notifySuccess('删除成功');
                            this.getOrderGoodsList();
                        }else{
                            return this.$notifyError(res.error);
                        }
                    } else {
                        return this.$notifyError(res.error);
                    }
                }
            },

            //筛选商品:只保留skuCode, skuName, barcode
            searchGoods(){
                let self = this;
                // console.log('this.orderGoodsList',this.orderGoodsList)
                if(this.goodsName!=""){
                    this.orderGoodsList = this.searchGoodsList.filter((item,index)=>{

                        if(
                            (item.skuCode && (item.skuCode.indexOf(self.goodsName) > -1))
                            || (item.skuName && (item.skuName.indexOf(self.goodsName) > -1))
                            || (item.barCode && (item.barCode.indexOf(self.goodsName) > -1))
                        ){
                            return item
                        }
                    })
                }
                else{
                    //this.orderGoodsList = sessionStorage.getItem("searchGoodsList");
                    this.orderGoodsList = this.searchGoodsList;
                }
            },
            addedit(tr){
                let addsb=[]
                this.splitGoodsList.map(iten=>{
                    iten.List.map(inds=>{
                        inds.editFlag = false
                        addsb.push(inds)
                    })
                })
                sessionStorage.setItem("addSkuItemList",JSON.stringify(addsb));
                this.splitGoodsList.map(item=>{
                    item.List.map(inda=>{
                        console.log(inda.editFlag)
                        inda.editFlag=false
                        // this.$set(tr,'editFlag',true);
                    })
                })
                tr.editFlag=true
            },
            async editAndSave(tr,index){
                if(tr.offerFlag){
                    let existsGood = this.orderGoodsList.filter(good => !good.offerFlag && good.hunitPrice >= 0 && tr.hunitPrice > 0);
                    if(existsGood.length != 0){
                        return this.$notifyError('当前商品已有，此商品为赠品，且成交价必须为0');
                    }
                }else{
                    let existsGoods = this.orderGoodsList.filter(good => good.offerFlag && good.hunitPrice <= 0 && tr.hunitPrice <= 0);
                    if(existsGoods.length != 0){
                        return this.$notifyError('当前商品为非赠品，且成交价必须大于0');
                    }
                }

                if(tr.num==""){
                    return this.$notifyError('修改数量不能为空');
                }
                if(Number(tr.num) < 0){
                    return this.$notifyError('修改数量不能小于0');
                }
                if(tr.hunitPrice==""){
                    return this.$notifyError('修改后的成交价不能为空');
                }
                if(Number(tr.hunitPrice) < 0){
                    return this.$notifyError('修改后的成交价不能小于0');
                }
                //编辑订单
                if(!this.newOrder){
                    alert()
                    let param = {
                        orderNo:this.orderNo,
                        updateSkuItemList:[{
                            skuCode: tr.skuCode,
                            hunitPrice: tr.hunitPrice,
                            num: tr.num,
                            id: tr.id,
                            offerFlag: tr.offerFlag
                        }]
                    };
                    let res = await OrderApi.updateGoodsInfo(param);
                    if (res.succ == 1) {
                        if(res.code == 0){
                            this.getOrderGoodsList();
                            this.$notifySuccess('修改成功');
                            this.isShowGoodsEditPopup = false
                        }
                        else{
                            return this.$notifyError(res.error);
                        }
                    } else {
                        return this.$notifyError(res.error);
                    }
                }else{
                    let addsb=[]
                    this.splitGoodsList.map(iten=>{
                        iten.List.map(inds=>{
                            inds.editFlag = false
                            addsb.push(inds)
                        })
                    })
                    sessionStorage.setItem("addSkuItemList",JSON.stringify(addsb));
                    this.orderGoodsList[index].editFlag = false;
                    // this.computeTotalPrice(this.orderGoodsList);

                }
                this.getEvenyGoods(JSON.parse(sessionStorage.getItem("addSkuItemList")));
                this.getEvenyOrder();
            },
            //计算金额
            computeTotalPrice(list){
                console.log(list)
                //计算总金额
                this.amountInfo.dealTotalPrice = 0;
                this.amountInfo.originalTotalPrice =0;
                this.amountInfo.discountTotalPrice = 0;
                list = list.map((item,index)=>{
                    //原价金额和成交 hunitPrice
                    item.itemPrice = Number(item.untilPrice) * Number(item.num);
                    item.hitemPrice = Number(item.hunitPrice) * Number(item.num);
                    // 成交总金额
                    this.amountInfo.dealTotalPrice += Number(item.hitemPrice)
                    //原价总金额
                    this.amountInfo.originalTotalPrice += Number(item.itemPrice);
                    return item;
                });
                this.amountInfo.dealTotalPrice = Number(this.amountInfo.dealTotalPrice.toFixed(2))
                this.amountInfo.originalTotalPrice = Number(this.amountInfo.originalTotalPrice.toFixed(2))
                // 折扣总金额
                this.amountInfo.discountTotalPrice = Number(Number(this.amountInfo.originalTotalPrice - this.amountInfo.dealTotalPrice).toFixed(2));
                // console.log("折扣总金额===", this.amountInfo.discountTotalPrice);
                console.log(this.amountInfo.dealTotalPrice,this.amountInfo.originalTotalPrice,this.amountInfo.discountTotalPrice)

                sessionStorage.setItem("addSkuItemList",JSON.stringify(list));
            },

            //更换商品
            async updateOrderGoods(row) {
                let resp = await OrderGoodsApi.list({ page: 1 });
                this.goodsData = resp.result;
                this.isShowUpdateForm = true;
            },
            // 成交价修改
            priceChange(tr,indextr){
                if(!tr.uid){
                    tr.uid = this.uid++;
                }
                if(tr.hunitPrice && tr.hunitPrice != '0.00' && tr.hunitPrice != 0){
                    tr.offerFlag = false;
                }else{
                    tr.offerFlag = true;
                }
                let existsGood = this.orderGoodsList.filter(good => good.offerFlag == tr.offerFlag && good.skuCode == tr.skuCode);
                if(existsGood.length != 0){
                    this.$notifyError("商品"+tr.skuName + '已存在,请删除后再次添加');
                    return;
                }
                if (tr.num) {
                    if (this.goodsListSelect.length) {
                        const tmp = this.goodsListSelect.filter(item => item.uid == tr.uid)
                        if (!tmp.length) {
                            this.goodsListSelect.push(tr)
                        } else {
                            this.goodsListSelect.map(item => {
                                if (item.uid == tr.uid) {
                                    item.hunitPrice = tr.hunitPrice
                                }
                            })
                            // this.goodsListSelect[indextr].hunitPrice = tr.hunitPrice
                        }
                    }
                }

            },
            // 批量添加保留修改项 todo
            numberChange(tr,indextr){
                if(!tr.uid){
                    tr.uid = this.uid++;
                }
                if(tr.hunitPrice && tr.hunitPrice != '0.00' && tr.hunitPrice != 0){
                    tr.offerFlag = false;
                }else{
                    tr.offerFlag = true;
                }
                // tr.num = this.goodsNum[indextr];
                console.log(this.orderGoodsList);
                console.log('tr', tr);
                let existsGood = this.orderGoodsList.filter(good => good.offerFlag == tr.offerFlag && good.skuCode == tr.skuCode);
                console.log('existsGood', existsGood)
                if(existsGood.length != 0){
                    this.$notifyError("商品"+tr.skuName + '已存在,请删除后再次添加');
                    return;
                }
                console.log('goodsListSelect', this.goodsListSelect);
                if (this.goodsListSelect.length > 0) {
                    let existsGoodIndex = this.goodsListSelect.findIndex(good => good.uid ==  tr.uid);
                    if(existsGoodIndex == -1){
                        // if(this.newOrder){
                        //   this.goodsListSelect.push(tr);
                        // }else{//编辑的时候判断订单是否有重复的商品
                        const exIndex = this.orderGoodsList.findIndex(good => good.uid == tr.uid);
                        if(exIndex == -1){
                            this.goodsListSelect.push(tr);
                        } else{
                            return this.$notifyError(("商品"+tr.skuName + '已存在,请删除后再次添加'));
                            //this.$set(this.goodsListSelect[existsGoodIndex], 'num', 0);
                        }
                        // }
                    } else{
                        this.goodsListSelect.forEach(item => {
                            if (item.uid ==  tr.uid) {
                                item.num = tr.num
                            }
                        })
                        this.orderGoodsList.forEach(item => {

                            if (item.uid ==  tr.uid) {
                                this.goodsListSelect.forEach(good => {
                                    if (good.uid ==  tr.uid) {
                                        // good.num = '',
                                        tr.num = '',
                                            tr.hunitPrice = '0.00'
                                    }
                                })
                                return this.$notifyError(("商品"+tr.skuName + '已存在,请删除后再次添加'));

                            }else {
                                this.goodsListSelect.forEach(item => {
                                    if (item.uid ==  tr.uid) {
                                        item.num =tr.num
                                    }
                                })
                            }
                        })

                    }
                } else {
                    this.goodsListSelect.push(tr)
                }
                // this.goodsList = this.goodsList.filter(item => {
                //   item.
                // })
                // this.goodsList = this.goodsList.concat(this.goodsList,this.goodsListSelect)
            },

            //修改商品信息成交价
            hunpriceChange(tr, indextr){
                let that = this;
                let existsGood = that.orderGoodsList.filter(good => good.skuCode == tr.skuCode && (good.uid != tr.uid || parseInt(good.orderType) != parseInt(tr.orderType)));
                if(existsGood.length == 0){
                    that.orderGoodsList.map((item,index) => {
                        if(tr.hunitPrice == '0.00' && indextr == index){
                            item.offerFlag = true;
                        }else{
                            item.offerFlag = false;
                        }
                    })
                }else{
                    this.$notifyError("商品"+tr.skuName + '已存在,请删除后再次添加');
                    return;
                }
            },

            //获取拆分订单
            getEvenyGoods(array){
                console.log(array)
                let dataArr = [];
                let index = 1;

                array.map(mapItem => {
                    mapItem.editFlag=false
                    if (dataArr.length == 0) {
                        dataArr.push({title: '订单' + index, bodyId: mapItem.bodyId, List: [mapItem] })
                    } else {
                        let res = dataArr.some(item=> {//判断相同日期，有就添加到当前项
                            if (item.bodyId == mapItem.bodyId) {
                                item.List.push(mapItem)
                                return true
                            }

                        })
                        if (!res) {//如果没找相同日期添加一个新对象
                            index++;
                            dataArr.push({title: '订单' + index, bodyId: mapItem.bodyId, List: [mapItem] })
                        }
                    }
                });
                this.splitGoodsList = dataArr;
                this.payOrder = this.splitGoodsList.map(item =>{
                    let obj ={};
                    obj.id = item.bodyId;
                    obj.label = item.title;
                    return obj;
                })
                this.getEvenyOrder();
                console.log(this.splitGoodsList)
            },

            //获取每个订单的价格
            getEvenyOrder(){
                this.splitGoodsList.map(item=>{
                    //成交金额总价
                    item.hunitPricenum=0
                    //原价总价
                    item.itemPricenum=0
                    //折扣总金额
                    item.discount=0
                    //实付金额
                    item.Paidinamount=0
                    this.payTypeList.map((indes,index)=>{
                        if(indes.bodyId==item.bodyId){

                            item.Paidinamount+=Number(indes.payPrice)
                            console.log(item.Paidinamount,indes.payPrice)
                        }else{
                            console.log(indes,index)
                            // this.payTypeList.splice(index,1)
                        }
                    })
                    item.List.map(inasd=>{
                        console.log(inasd.hunitPrice,inasd.itemPrice)
                        inasd.hitemPrice=Number(inasd.num)*Number(inasd.hunitPrice)
                        //成交金额总价
                        item.hunitPricenum += Number(inasd.hitemPrice)
                        //原价总价
                        item.itemPricenum += Number(inasd.itemPrice)
                        //折扣总金额
                        item.discount=item.itemPricenum-item.hunitPricenum
                    })
                    console.log(item)
                })
                // this.splitGoodsList.map((item, index) => {
                //   if(item.bodyId == item.List[0].bodyId){
                //     item.List.map(childitem => {
                //       //原价金额和成交 hunitPrice
                //       childitem.itemPrice = Number(childitem.untilPrice) * Number(childitem.num);
                //       childitem.hitemPrice = Number(childitem.hunitPrice) * Number(childitem.num);
                //       // 成交总金额
                //       dealTotalPrice += Number(childitem.hitemPrice)
                //       //原价总金额
                //       originalTotalPrice += Number(childitem.itemPrice);
                //     })
                //     item.dealTotalPrice = Number(dealTotalPrice.toFixed(2))
                //     item.originalTotalPrice = Number(originalTotalPrice.toFixed(2))
                //     dealTotalPrice = 0;
                //     originalTotalPrice = 0;
                //     if(this.payTypeList.length > 0){
                //       this.payTypeList.map((ele, idx)=>{
                //         if(ele.bodyId == item.bodyId){
                //           actualTotalPrice += Number(ele.payPrice)
                //           item.actualTotalPrice = actualTotalPrice
                //           // 折扣总金额
                //           item.discountTotalPrice = Number(Number(item.originalTotalPrice - item.dealTotalPrice).toFixed(2));
                //         }
                //       })
                //       actualTotalPrice = 0;
                //     }else{
                //       item.dealTotalPrice = dealTotalPrice;
                //       item.discountTotalPrice =  Number(Number(item.originalTotalPrice - dealTotalPrice).toFixed(2));
                //     }
                //   }
                // })

                console.log(this.splitGoodsList)
            }
        },

        watch: {
            'pager.page'() {
                this.getTableData();
            },
            isShowUpdateForm(value){
                if(value){
                    this.getTableData();
                }
            },

            orderNo:{
                handler(newVal,oldVal){
                    if(newVal){
                        this.getOrderGoodsList()
                    }
                },
                immediate: true
            },
            currencyType(val){
                const cIndex = this.currencyTypeList.findIndex(item => item.id == val);
                this.currencySymbol = this.currencyTypeList[cIndex].symbol;
                this.currencyShow = val;
            },
            //更新币种
            currencySymbol(){
                this.$emit('updateCurrency', this.currencySymbol);
            },
            orderGoodsList(array){
                this.getEvenyGoods(JSON.parse(sessionStorage.getItem("addSkuItemList")));
            },
            payTypeList(){
                this.getEvenyOrder();
            }
        },

        components: {
            flatPickr,
            'v-select': vSelect,
            GcCmpVsInput,
        }
    };
</script>

<style>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
    .new-goods-pop .vs-table--content {
        height: 400px !important;
    }
</style>

<style lang="scss" scoped>
    @import '@/modules/commodity-sys/commodity.scss';
    @mixin flex-mixin($direction, $align, $justify) {
        display: flex;
        flex-direction: $direction;
        align-items: $align;
        justify-content: $justify;
    }
    .order-title{
        text-align:center;
        line-height: 40px;
        font-weight: bold;
    }
    .sku-list {
        width: 100%;
        .line {
            @include flex-mixin(row, center, space-between);
            margin-bottom: 6px;
            .lf {
                @include flex-mixin(row, center, flex-start);
                .search {
                    margin-left: 10px;
                }
                /deep/ .vs-button {
                    padding: 8px 25px !important;
                }
            }
            .btn{margin-left: 10px;}
        }
        .a_btn {
            //display: inline-block;
            padding: 0 !important;
            margin-right: 12px;
        }

        /deep/ .vs-con-tbody {
            max-height: 300px;
            overflow: auto;
        }

    }
    .goods-popup /deep/ .vs-popup{
        width: 1100px;
    }
    /deep/ .new-goods-pop{
        min-height: 500px;;
        .category-select{
            width: 300px;
        }
    }
    .amount-wrap{
        text-align: right;
        margin-top: 20px;
        .amount-value{
            // min-width: 6%;
            display: inline-block;
            text-align: left;
        }
        span{
            margin-right: 10px;
        }
    }
    .modify /deep/ span{
        display: inline-block;
        align-items: center;
    }
    .text-primary{
        margin-left: 10px;
        cursor: pointer;
    }
    .pay-wrap{
        padding-bottom: 40px;
        h1{
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .pay-info{
            display: flex;
            align-items: center;
            div{
                width: 14%;
                margin-left: 30px;
                span{
                    margin-right: 10px;
                }
            }
        }
    }

    #currencySelect.v-select{
        width: 150px;
    }
    .marLeft-10{
        margin-left: 10px;
    }
    .amount-red{
        color: #F56C6C;
    }
</style>
